import React from 'react'
import _ from 'lodash'
// "Batteries included" version of the <Map /> component. Does the data-fetching
// and object construction for you. Not recommended if you're going to be
// displaying more than one map on a page.
import { Map } from 'common/Map'

import fetchJSON from 'lib/fetchJSON'
import { deserializeTrip, deserializeRoute } from 'lib/api/records'

export class SimpleMap extends React.Component {
  constructor (props) {
    super(props)
    this.state = { routes: [] }
    this._routeCache = {}
    this._tripCache = {}
  }

  // This is an instance where using ImmutableJS would make
  // shallow comparison a feasible shouldComponentUpdate approach.
  // Instead, we have to check the array elements with a deep compare
  shouldComponentUpdate (nextProps, nextState) {
    return (
      !_.isEqual(this.props, nextProps) ||
      !_.isEqual(this.state, nextState)
    )
  }

  // get route JSON data - TODO: error handling logic
  getRoute = (routeId) => {
    const getRouteURL = (routeId) => (
      this.props.privacyCodes
        ? `/routes/${routeId}.json?apikey=x&version=2&privacy_code=${this.props.privacyCodes[routeId]}`
        : `/routes/${routeId}.json?apikey=x&version=2`
    )
    if (!this._routeCache[routeId]) {
      this._routeCache[routeId] = fetchJSON(getRouteURL(routeId))
        .then(res => {
          if (res.type === 'route') {
            return deserializeRoute(res.route)
          } else {
            return deserializeTrip(res.trip)
          }
        })
    }

    return this._routeCache[routeId]
  }

  componentDidMount () {
    this.fetchData()
  }

  componentDidUpdate (prevProps, prevState) {
    if (!_.isEqual(prevProps.routeIds, this.props.routeIds)) {
      this.fetchData()
    }
  }

  fetchData = () => {
    // Grab the data
    Promise.all(this.props.routeIds.map(this.getRoute))
      .then((data) => {
        this.setState({ routes: data })
      })
  }

  render () {
    const { width, height, mapSettings, showNativeFullscreen, onToggleSetting, sampleGraph, metricUnits, defaultOverlay, experimental, showToolbar } = this.props
    const { routes } = this.state

    if (!routes || routes.length === 0) {
      return null
    }

    return <Map
      showNativeFullscreen={showNativeFullscreen}
      showToolbar={showToolbar}
      experimental={experimental}
      width={width}
      height={height}
      mapSettings={mapSettings}
      onToggleSetting={onToggleSetting}
      defaultOverlay={defaultOverlay}
      sampleGraph={sampleGraph}
      routes={routes}
      metricUnits={metricUnits} />
  }
}
